export default {"src":"/_next/static/media/reading.13201963.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};